"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Chat = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _reactIcons = require("@100mslive/react-icons");
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _ChatFooter = require("./ChatFooter");
var _ChatHeader = require("./ChatHeader");
var _ChatBody = require("./ChatBody");
var _useUnreadCount = require("./useUnreadCount");
var _useSetPinnedMessage2 = require("../hooks/useSetPinnedMessage");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PinnedMessage = function PinnedMessage(_ref) {
  var clearPinnedMessage = _ref.clearPinnedMessage;
  var permissions = (0, _reactSdk.useHMSStore)(_reactSdk.selectPermissions);
  var pinnedMessage = (0, _reactSdk.useHMSStore)(_reactSdk.selectSessionMetadata);
  return pinnedMessage ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    css: {
      p: "$8",
      color: "$textMedEmp",
      bg: "$surfaceLight",
      r: "$1"
    },
    align: "center",
    justify: "between",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.PinIcon, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Box, {
      css: {
        ml: "$8",
        color: "$textMedEmp",
        w: "100%",
        maxHeight: "$18",
        overflowY: "auto"
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
        variant: "sm",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatBody.AnnotisedMessage, {
          message: pinnedMessage
        })
      })
    }), permissions.removeOthers && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.IconButton, {
      onClick: function onClick() {
        return clearPinnedMessage();
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.CrossIcon, {})
    })]
  }) : null;
};
var Chat = function Chat() {
  var _useState = (0, _react.useState)({
      role: "",
      peerId: "",
      selection: "Everyone"
    }),
    _useState2 = _slicedToArray(_useState, 2),
    chatOptions = _useState2[0],
    setChatOptions = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSelectorOpen = _useState4[0],
    setSelectorOpen = _useState4[1];
  var bodyRef = (0, _react.useRef)(null);
  var hmsActions = (0, _reactSdk.useHMSActions)();
  var _useSetPinnedMessage = (0, _useSetPinnedMessage2.useSetPinnedMessage)(),
    setPinnedMessage = _useSetPinnedMessage.setPinnedMessage;
  var scrollToBottom = (0, _react.useCallback)(function () {
    var instant = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!bodyRef.current) {
      return;
    }
    bodyRef.current.scrollTo({
      top: bodyRef.current.scrollHeight,
      behavior: instant ? "instant" : "smooth"
    });
    hmsActions.setMessageRead(true);
  }, [hmsActions]);
  (0, _react.useEffect)(function () {
    scrollToBottom(true);
  }, [scrollToBottom]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    direction: "column",
    css: {
      size: "100%"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatHeader.ChatHeader, {
      selectorOpen: isSelectorOpen,
      selection: chatOptions.selection,
      onSelect: setChatOptions,
      role: chatOptions.role,
      peerId: chatOptions.peerId,
      onToggle: function onToggle() {
        setSelectorOpen(function (value) {
          return !value;
        });
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PinnedMessage, {
      clearPinnedMessage: setPinnedMessage
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      direction: "column",
      css: {
        flex: "1 1 0",
        overflowY: "auto",
        pt: "$4",
        position: "relative",
        // Below two are for pushing scroll to the edge of the box
        mr: "-$10",
        pr: "$10"
      },
      ref: bodyRef,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatBody.ChatBody, {
        role: chatOptions.role,
        peerId: chatOptions.peerId,
        setPinnedMessage: setPinnedMessage
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ScrollHandler, {
        scrollToBottom: scrollToBottom,
        role: chatOptions.role,
        peerId: chatOptions.peerId
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatFooter.ChatFooter, {
      role: chatOptions.role,
      peerId: chatOptions.peerId,
      onSend: scrollToBottom,
      children: !isSelectorOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(NewMessageIndicator, {
        role: chatOptions.role,
        peerId: chatOptions.peerId,
        scrollToBottom: scrollToBottom
      })
    })]
  });
};
exports.Chat = Chat;
var NewMessageIndicator = function NewMessageIndicator(_ref2) {
  var role = _ref2.role,
    peerId = _ref2.peerId,
    scrollToBottom = _ref2.scrollToBottom;
  var unreadCount = (0, _useUnreadCount.useUnreadCount)({
    role: role,
    peerId: peerId
  });
  if (!unreadCount) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Flex, {
    justify: "center",
    css: {
      width: "100%",
      left: 0,
      bottom: "100%",
      position: "absolute"
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Button, {
      onClick: function onClick() {
        scrollToBottom();
      },
      css: {
        p: "$2 $4",
        "& > svg": {
          ml: "$4"
        }
      },
      children: ["New Messages", /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.ChevronDownIcon, {
        width: 16,
        height: 16
      })]
    })
  });
};
var ScrollHandler = function ScrollHandler(_ref3) {
  var scrollToBottom = _ref3.scrollToBottom,
    role = _ref3.role,
    peerId = _ref3.peerId;
  var _useInView = (0, _reactIntersectionObserver.useInView)({
      threshold: 0.5
    }),
    ref = _useInView.ref,
    inView = _useInView.inView;
  var unreadCount = (0, _useUnreadCount.useUnreadCount)({
    role: role,
    peerId: peerId
  });
  (0, _react.useEffect)(function () {
    if (inView && unreadCount) {
      scrollToBottom();
    }
  }, [inView, unreadCount, scrollToBottom]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: ref,
    style: {
      height: 1
    }
  });
};